import { AsyncStoreItem } from '@lib';

/**
 * StandbyCancelResult model
 */
export interface StandbyCancelResultModel {
  model: any;
}

/**
 * PostStandbyCancelRequest model details
 */
export interface StandbyCancelResultStateDetails extends AsyncStoreItem {}

/**
 * StandbyCancelResult store state
 */
export interface StandbyCancelResultState extends StandbyCancelResultStateDetails, StandbyCancelResultModel {}

/**
 * Name of the StandbyCancelResult Store
 */
export const STANDBY_CANCEL_RESULT_STORE_NAME = 'standbyCancelResult';

/**
 * StandbyCancelResult Store Interface
 */
export interface StandbyCancelResultStore {
  /** StandbyCancelResult state */
  [STANDBY_CANCEL_RESULT_STORE_NAME]: StandbyCancelResultState;
}
